import { Injectable } from '@angular/core';
import {
    AbstractDataServiceDtoAdapter
} from '../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {InsolesModelDataService} from './insolesModel.data.service';
import {InsolesModelModel} from "../../../api/entity/insolesModel.model";
import {InsolesModelConverter} from "../../../api/entity/insolesModel.converter";

@Injectable()
export class InsolesModelDataServiceAdapter
    extends AbstractDataServiceDtoAdapter<InsolesModelModel, InsolesModelConverter> {
    constructor(dataService: InsolesModelDataService, converter: InsolesModelConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): InsolesModelModel {
        return new InsolesModelModel();
    }
}
